<span class="subject-management-status-badge" [ngClass]="[sizeClass, toneClass]">
  {{ displayLabel }}
</span>
